import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconCheck } from '@redteclab/icons'

import { IconListItem } from 'base-ui'

export const RedPointsBenefitList: FC = () => (
  <ul className="ml-2">
    <IconListItem
      className="flex flex-row items-center text-dark-primary-strong"
      icon={<IconCheck className="size-8 text-dark-brand" />}
    >
      <FormattedMessage id="redpoints.modal.benefit1" />
    </IconListItem>
    <IconListItem
      className="flex flex-row items-center text-dark-primary-strong"
      icon={<IconCheck className="size-8 text-dark-brand" />}
    >
      <FormattedMessage id="redpoints.modal.benefit2" />
    </IconListItem>
    <IconListItem
      className="flex flex-row items-center text-dark-primary-strong"
      icon={<IconCheck className="size-8 text-dark-brand" />}
    >
      <FormattedMessage id="redpoints.modal.benefit3" />
    </IconListItem>
  </ul>
)
